// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1iFa4","title":"FrontImage_title__u2Pln"};